import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  white-space: pre-line;
  gap: ${theme.typography.sizes.sm};
`
export const FieldWrapper = styled('div')`
  width: 100%;
`
